module.exports = __webpack_public_path__ + "img/n9.055e010d.png";